import { Bar } from 'vue-chartjs'

export default {
  extends: Bar,
  props: ['group', 'title', 'company', 'date'],
  data () {
    return {
    	dataset: {},
			isRendered: false
    }
  },
  computed: {
  	chartData () {
  		return this.dataset
		},
  	options () {
			return {
				scales: {
					yAxes: [{
						ticks: {
							beginAtZero: true
						},
						gridLines: {
							display: true
						}
					}],
						xAxes: [{
						ticks: {
							beginAtZero: true
						},
						gridLines: {
							display: false
						}
					}]
				},
				legend: {
					display: false
				},
				responsive: true,
				maintainAspectRatio: false
			}
		}
	},
  methods: {
  	getData () {
			if (this.isRendered) {
				this.$data._chart.destroy()
			}
			API.get(`ecommerce/top-selling-brands/${this.group}/${this.company.id}?start=${this.date.split('#')[0]}&end=${this.date.split('#')[1]}`)
				.then(res => {
					res.data.datasets = this.formatBarDatasets(res.data.datasets)
					this.dataset = res.data
				})
		}
	},
  mounted () {
		API.get(`ecommerce/top-selling-brands/${this.group}/${this.company.id}?start=${this.date.split('#')[0]}&end=${this.date.split('#')[1]}`)
			.then(res => {
				res.data.datasets = this.formatBarDatasets(res.data.datasets)
				this.dataset = res.data
				this.isRendered = true
			})
  },
  watch: {
    company () {
    	this.getData()
    },
		dataset () {
			this.renderChart(this.dataset, this.options)
		},
		group () {
			this.getData()
		},
		date () {
			this.getData()
		}
  }
}



// WEBPACK FOOTER //
// ./src/components/tools/Charts/TopBrandsChart.js